import Vue from 'vue'
import VueI18n from 'vue-i18n'

// Inject global dependencies to Vue
Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'fi',
  messages: {
    fi: {
      // Headings
      'heading.documentSelectionPage-environment-bulletin': 'Palvelussa näytettävät EHS-tiedotteet',
      'heading.documentSelectionPage-government-bill': 'Palvelussa näytettävät hallituksen esitykset',
      'heading.documentSelectionPage-news-article': 'Palvelussa näytettävät uutiset',
      'heading.moduleMaterialTypesPage': 'Palveluun sisältyvät dokumenttityypit',
      'heading.loginPage': 'Kirjaudu sisään',

      // Labels
      'label.default': 'Oletus',
      'label.document': 'Dokumentti',
      'label.displayedInService': 'Näytetään palvelussa',
      'label.lang-fi': 'suomi',
      'label.lang-sv': 'ruotsi',
      'label.login': 'Kirjaudu sisään',
      'label.notDisplayedInService': 'Ei näytetä palvelussa',
      'label.materialType-environment-bulletin': 'EHS-tiedotteet',
      'label.materialType-government-bill': 'Hallituksen esitykset',
      'label.materialType-news-article': 'Uutiset',
      'label.password': 'Salasana',
      'label.passwordIsRequired': 'Salasana vaaditaan',
      'label.showResultsPerPage': 'Näytä tuloksia sivulla',
      'label.username': 'Käyttäjätunnus',
      'label.usernameIsRequired': 'Käyttäjätunnus vaaditaan',

      // Notifications
      'notification.loginFailed': 'Kirjautuminen epäonnistui',
      'notification.updateSelectedByEditorFailure': 'Valinnan tallentaminen epäonnistui',
      'notification.updateSelectedByEditorSuccess': 'Valinta tallennettu'
    }
  }
})

export default i18n
